import React from 'react';

import { ReactComponent as InfoIcon } from '@/assets/icons/exclamation-mark.svg';
import CommonImage from '@/components/CommonImage';
import { convertDateToLocal, getUserInfo, replaceUnderLine } from '@/utils/Util';
import { isIssueCreator, isNotifyUser, isResponsiblePerson } from '@/features/design/utils/designUtils';

const IssueAndStatusSection = ({
	onShowIssueModal,
	onShowUpdateTask,
	setSelectedIssueToEdit,
	designDetails,
	issueList,
	activeIssueIndex,
	setActiveIssueIndex
}) => {
	const getUserData = getUserInfo();

	return (
		<div className="style-update-info-and-slider d-grid gap-4 mb-3">
			<div className="style-last-updated-info">
				<p className="medium-12 gray_dark_02">TP last status:</p>
				<div className="style-update-status-item pt-10 d-flex flex-column gap-2 align-items-start">
					<div>
						{designDetails?.lastTask?.name && (
							<span className="status yellow-1 without-nowrap status-with-border">
								{designDetails?.lastTask?.name}
							</span>
						)}
						{designDetails?.lastTask?.sampleReviewStatus && (
							<span className="status yellow-1 without-nowrap status-with-border mt-1">
								{replaceUnderLine(designDetails?.lastTask?.sampleReviewStatus)}
							</span>
						)}
					</div>

					<p className="regular-12 gray_dark_01 pl-1">
						{designDetails?.lastTaskCreatedAt &&
							convertDateToLocal(designDetails?.lastTaskCreatedAt, 'DD MMM, YY')}
						{designDetails?.lastTaskCreatedBy?.nickName
							? ` by ${designDetails?.lastTaskCreatedBy?.nickName}`
							: ''}
					</p>
				</div>
			</div>

			<div className="slider-information d-flex  justify-content-between">
				{issueList?.length > 0 ? (
					<>
						<div className="single-slider">
							<div className="slider-information-item d-flex flex-column justify-content-between h-100">
								<div className="slider-info-top d-flex justify-content-start align-item-start">
									<p className="medium-12 gray_dark_02 white-space-nowrap">
										Pending issue:{' '}
										<span className="gray_dark_01">
											{activeIssueIndex + 1}/{issueList?.length}
										</span>
									</p>
									<div className="all-status d-flex align-items-start gap-1 ml-2">
										{issueList[activeIssueIndex]?.issueTypeList
											?.slice(0, 2)
											.map((type, idx) => (
												<span className="status red-3" key={idx}>
													{replaceUnderLine(type, true)}
												</span>
											))}
									</div>

									{issueList[activeIssueIndex]?.issueTypeList?.length > 2 && (
										<div className="select-component ml-2">
											<div
												className="click-box more-click-box click bg-transparent p-0 d-flex align-items-center gap-1 shadow-none"
												data-toggle="dropdown"
											>
												<p className="d-flex align-items-center gap-1 regular-14 weight-500 gray_dark_01 text-underline pl-1">
													+{issueList[activeIssueIndex].issueTypeList.length - 2}
												</p>
											</div>
											<div className="dropdown-box dropdown-menu">
												<div className="list-items scroll-y-label">
													{issueList[activeIssueIndex].issueTypeList
														.slice(2)
														.map((status, idx) => (
															<div className="single-item" key={idx}>
																<p>{replaceUnderLine(status, true)}</p>
															</div>
														))}
												</div>
											</div>
										</div>
									)}
								</div>
								<div className="date-and-creator d-flex align-items-start mt-1">
									<spna className="dot top-3 left-0 d-none"></spna>
									<p className="regular-12 gray_dark_01 white-space-nowrap">
										{convertDateToLocal(
											issueList[activeIssueIndex]?.createdAt,
											'DD MMM, YY'
										)}
									</p>
									{issueList[activeIssueIndex]?.createdBy?.nickName && (
										<p className="regular-12 gray_dark_01 mx-1 white-space-nowrap">
											by {issueList[activeIssueIndex]?.createdBy?.nickName}
										</p>
									)}

									{issueList[activeIssueIndex]?.holdDevelopment && (
										<p className="regular-12 gray_dark_01 white-space-nowrap">
											<InfoIcon /> <span>TP hold</span>
										</p>
									)}

									{(isIssueCreator(getUserData, issueList[activeIssueIndex]) ||
										isResponsiblePerson(getUserData, issueList[activeIssueIndex]) ||
										isNotifyUser(getUserData, issueList[activeIssueIndex])) && (
										<>
											<span className="mx-2">|</span>
											<p
												className="regular-12 gray_dark_01 text-underline white-space-nowrap cursor-pointer"
												onClick={() =>
													setSelectedIssueToEdit(issueList[activeIssueIndex])
												}
											>
												Solve this issue
											</p>
										</>
									)}
								</div>
								<div className="slider-info-bottom">
									<p className="regular-12 gray_dark_02">
										Details:{' '}
										<span className="gray_dark_01">
											{issueList[activeIssueIndex]?.details}
										</span>
									</p>
								</div>
							</div>
						</div>
						<div className="slider-arrow d-flex justify-content-start align-items-center gap-1">
							<CommonImage
								className={`${activeIssueIndex > 0 ? 'cursor-pointer' : 'cursor-none'}`}
								src="/icons/Left-arrow.svg"
								width={24}
								height={24}
								onClick={() => {
									if (activeIssueIndex > 0) {
										setActiveIssueIndex(activeIssueIndex - 1);
									}
								}}
							/>
							<CommonImage
								className={`${activeIssueIndex < issueList?.length - 1 ? 'cursor-pointer' : 'cursor-none'}`}
								src="/icons/right-arrow.svg"
								width={24}
								height={24}
								onClick={() => {
									if (activeIssueIndex < issueList?.length - 1) {
										setActiveIssueIndex(activeIssueIndex + 1);
									}
								}}
							/>
						</div>
					</>
				) : (
					<div className="w-100">
						<p className="medium-12 gray_dark_02 text-start">Pending issue</p>
						<p className="d-flex align-items-center justify-content-center regular-14 gray_dark_02 py-2">
							No issue created yet!
						</p>
					</div>
				)}
			</div>

			<div className="create-and-take-btn d-flex justify-content-start align-items-center gap-4 h-100">
				<p
					className="regular-14 gray_dark_01 text-underline white-space-nowrap cursor-pointer"
					onClick={() => {
						setSelectedIssueToEdit(null);
						onShowIssueModal();
					}}
				>
					Raise issue
				</p>
				<p
					className="regular-14 gray_dark_01 text-underline white-space-nowrap cursor-pointer"
					onClick={onShowUpdateTask}
				>
					Update task
				</p>
			</div>
		</div>
	);
};

export default IssueAndStatusSection;
